<template>
    <div style="overflow-x: auto; width: 100%;">
        <div class="filter-container horizontal" style="min-width: 790px;">
            <div v-if="showFilters.includes('All')" class="filter-button-container">
                <div class="filter-button horizontal" :style="lastClicked === 'All' ? 'background-color: rgba(0, 125, 149, 1); color: white;' : ''" @click="changeMode('All')">
					<img v-if="lastClicked !== 'All'" src="../../assets/img/Systems/Filter/Passive_All_Systems.svg" alt="All systems passive"/>
					<img v-else src="../../assets/img/Systems/Filter/Active_All_Systems.svg" alt="All systems active"/>
					<div class="filter-title">
						<div class="filter-button-number">{{ systemFilters[0] }}</div>
						<span class="filter-button-header" :style="lastClicked === 'All' ? 'color: white;' : ''">{{ $t('ALL_SYSTEMS') }}</span>
					</div>
                </div>
            </div>
            <div v-if="showFilters.includes('Active')" class="filter-button-container">
                <div class="filter-button horizontal" :style="lastClicked === 'Active' ? 'background-color: rgba(0, 125, 149, 1); color: white;' : ''" @click="changeMode('Active')">
					<img v-if="lastClicked !== 'Active'" src="../../assets/img/Systems/Filter/Passive_Active_Monitoring.svg" alt="active monitoring passive icon"/>
					<img v-else src="../../assets/img/Systems/Filter/Active_Active_Monitoring.svg" alt="active monitoring active icon"/>
					<div class="filter-title">
						<div class="filter-button-number">{{ systemFilters[1] }}</div>
						<span class="filter-button-header" :style="lastClicked === 'Active' ? 'color: white;' : ''">{{ $t('ACTIVE_MONITORING') }}</span>
					</div>
                </div>
            </div>
            <div v-if="showFilters.includes('NoMonitoring')" class="filter-button-container">
                <div class="filter-button horizontal" :style="lastClicked === 'NoMonitoring' ? 'background-color: rgba(0, 125, 149, 1); color: white;' : ''" @click="changeMode('NoMonitoring')">
					<img v-if="lastClicked !== 'NoMonitoring'" src="../../assets/img/Systems/Filter/Passive_Eye_Disabled.svg" alt="no monitoring passive"/>
					<img v-else src="../../assets/img/Systems/Filter/Active_Eye_Disabled.svg" alt="no monitoring active"/>
					<div class="filter-title">
						<div class="filter-button-number">{{ systemFilters[2] }}</div>
						<span class="filter-button-header" :style="lastClicked === 'NoMonitoring' ? 'color: white;' : ''">{{ $t('WITHOUT_MONITORING') }}</span>
					</div>
                </div>
            </div>
            <div v-if="showFilters.includes('Working')" class="filter-button-container">
                <div class="filter-button horizontal" :style="lastClicked === 'Working' ? 'background-color: rgba(0, 125, 149, 1); color: white;' : ''" @click="changeMode('Working')">
					<img v-if="lastClicked !== 'Working'" src="../../assets/img/Systems/Filter/Passive_Work_Fine.svg" alt="Working fine passive"/>
					<img v-else src="../../assets/img/Systems/Filter/Active_Work_Fine.svg" alt="Working fine active"/>
					<div class="filter-title">
						<div class="filter-button-number">{{ systemFilters[3] }}</div>
						<span class="filter-button-header" :style="lastClicked === 'Working' ? 'color: white;' : ''">{{ $t('WORKING_FINE') }}</span>
					</div>
                </div>
            </div>
            <div v-if="showFilters.includes('Issues')" class="filter-button-container">
                <div class="filter-button horizontal" :style="lastClicked === 'Issues' ? 'background-color: rgba(0, 125, 149, 1); color: white;' : ''" @click="changeMode('Issues')">
					<img v-if="lastClicked !== 'Issues'" src="../../assets/img/Systems/Filter/Passive_With_Issues.svg" alt="Systems with issues passive icon"/>
					<img v-else src="../../assets/img/Systems/Filter/Active_With_Issues.svg" alt="Systems with issues active icon"/>
					<div class="filter-title">
						<div class="filter-button-number">{{ systemFilters[4] }}</div>
						<span class="filter-button-header" :style="lastClicked === 'Issues' ? 'color: white;' : ''">{{ $t('WITH_ISSUES') }}</span>
					</div>
                </div>
            </div>
            <div v-if="showFilters.includes('ToCheckup')" class="filter-button-container">
              <div class="filter-button horizontal" :style="lastClicked === 'ToCheckup' ? 'background-color: rgba(0, 125, 149, 1); color: white;' : ''" @click="changeMode('ToCheckup')">
                <img v-if="lastClicked !== 'ToCheckup'" src="../../assets/img/Systems/Filter/Passive_With_Issues.svg" alt="Systems to checkup passive icon"/>
                <img v-else src="../../assets/img/Systems/Filter/Active_With_Issues.svg" alt="Systems to checkup active icon"/>
                <div class="filter-title">
                  <div class="filter-button-number">{{ systemFilters[5] }}</div>
                  <span class="filter-button-header" :style="lastClicked === 'ToCheckup' ? 'color: white;' : ''">{{ $t('TO_CHECKUP') }}</span>
                </div>
              </div>
            </div>
            <div v-if="mapFitButton" class="filter-button-container" :style="shouldZoom ? 'opacity: 100%;' : 'opacity: 25%;'"  style="margin: 10px; padding: 10px; border-left: 1px solid rgba(224, 224, 224, 1)">
                <div :style="!shouldZoom ? 'cursor: not-allowed;' : ''" class="filter-button horizontal" @click="shouldZoom ? $emit('fit') : {}">
                    <!-- <div :style="shouldZoom" class="svg-eye"></div> -->
					<img src="../../assets/img/Systems/Filter/Passive_Active_Monitoring.svg" alt="Systems with issues passive icon"/>
					<div class="filter-title">
						<div class="filter-button-number">{{ $t('FIT_EVERYTHING') }}</div>
                        <span class="filter-button-header">{{ $t('FIT_MAP_TO_SHOW_ALL') }}</span>
					</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSystemsOverview } from '@api'

export default {
    props: {
        initialClicked: {
            default: "Active"
        },
        showFilters: {
            default: () => ["All", "Active", "NoMonitoring", "Working", "Issues", "ToCheckup"],
            required: false
        },
        mapFitButton: {
            required: false,
            default: false,
            type: Boolean
        },
        shouldZoom: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            systemFilters: [0,0,0,0,0,0],
            lastClicked: this.initialClicked
        }
    },
    methods: {
        async getData() {
            this.systemFilters = await getSystemsOverview();
        },
        changeMode(mode){
        	this.getData();
            this.lastClicked = mode;
            this.$emit('modeChanged', mode)
        }
    },
    mounted: async function() {
        await this.getData()
    }
}
</script>

<style scoped>
.filter-container {
    width: 100%;
    margin-bottom: 20px;
    font-size: 11px;
    font-family: 'SourceSansProSemiBold', sans-serif !important;
    align-items: center;
}

.filter-button {
	background-color: rgba(243, 243, 243, 1);
    cursor: pointer;
	padding: 0 12px;
    border: 1px solid rgba(224, 224, 224, 1);
	border-radius: 5px;
}

.filter-button-container {
    /*padding-left: 20px;*/
	padding-right: 5px;
}

.filter-button-number {
    font-size: 13px;
    font-weight: bolder;
    align-self: center;
}

.filter-button-header {
    align-self: center;
    color: #777;
}

.filter-title {
	display: block;
	align-content: flex-start;
	margin: 5px 0 5px 5px;
}

/* .svg-eye {
    background-color: black;
    -webkit-mask: url('../../assets/img/Systems/Filter/Passive_Active_Monitoring.svg') no-repeat center;
    mask: url('../../assets/img/Systems/Filter/Passive_Active_Monitoring.svg') no-repeat center;
} */
</style>



// WEBPACK FOOTER //
// src/components/Systems/SystemsFilter.vue